import { hbs } from 'ember-cli-htmlbars';
export default hbs('{{outlet}}', { moduleName: 'later/templates/subscription.hbs' });
